export enum SocialChannel {
  Facebook = 'Facebook',
  Instagram = 'Instagram'
}

export const SocialChannels: SocialChannel[] = [
  SocialChannel.Facebook,
  SocialChannel.Instagram
];
